// stake checker function checks stake validation 
// receives 3 arguments : stake, max and min stake 
// returns valid stake 
export default function stakeChecker(
    stake: string,
    minStake: string,
    maxStake: string,
) {
    if (isNaN(+stake)) {
        return minStake
    }
    if (+stake < +minStake) {
        return minStake
    }
    if (+stake > +maxStake) {
        return maxStake
    }

    return stake
}
